// extracted by mini-css-extract-plugin
export default {"languages-icon":"languages-icon-YhHXjAB","language-button":"language-button-HONbtQK"};